<template>
  <div :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }">
    <div class="footer">
      <div class="footer-left">
        <div class="footer-left-logo">
          <img
            src="@/assets/images/qcyn-footer-bg.png"
            alt="七彩云南智选地，云南省建设用地招商云平台"
          />
        </div>
        <div class="footer-left-content">
          <div class="footer-left-content-titile">
            版权所有 <span>{{ copyright }}</span>
          </div>
          <div class="footer-left-content-titile">
            技术支持<span>{{ technology }}</span>
          </div>
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-right-content">
          <div class="footer-right-content-titile">
            承 办 <span>{{ undertake }}</span>
          </div>
          <div class="footer-right-content-titile">
            ICP备案/许可证号<span>{{ icp }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-contact">
      <div class="contact-phone">
        联系电话 <span>0871-64165127(周一至周五09:00-17:30)</span>
      </div>
      <div class="contact-support">
        技术支持 <span>0851-84109522(周一至周五09:00-17:30)</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      copyright: "云南省自然资源厅",
      technology: "贵州图智信息技术有限公司",
      undertake: "云南省测绘资料档案馆(云南省基础地理信息中心)",
      icp: "滇ICP备16002938号",
      screenIndexWidth: null,
    };
  },
  created() {},
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
  },
  methods: {},
};
</script>

<style scoped>
.footer {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 86px;
  /* background: red; */
}
.footer-left {
  width: 49%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.footer-left-logo {
  width: 232px;
  height: 68px;
}
.footer-left-logo img {
  width: 232px;
  height: 68px;
}
.footer-left-content {
  width: 51%;
  height: 68px;
}
.footer-left-content-titile {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  height: 30px;
  line-height: 30px;
}
.footer-left-content-titile span {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  padding-left: 10px;
}
.footer-right {
  width: 49%;
  height: 100%;
}
.footer-right-content {
  width: 100%;
  height: 68px;
}
.footer-right-content-titile {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  height: 30px;
  line-height: 30px;
}
.footer-right-content-titile span {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  padding-left: 10px;
}
.footer-contact {
  padding-top: 14px;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #979797;
}
.contact-phone {
  width: 60%;
  height: 100%;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
}
.contact-phone span {
  font-size: 14px;
  font-weight: 400;
  padding-left: 10px;
}
.contact-support {
  width: 40%;
  height: 100%;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
}
.contact-support span {
  font-size: 14px;
  font-weight: 400;
  padding-left: 10px;
}
</style>